<template>
  <div>
    <header class="game">
      <a style="cursor: pointer" class="logo_score" @click.prevent="goToHomePage">
        <img :src="getTranslations.project_logo_img_white" alt="">
      </a>
      <div class="player_section">
        <div class="name_points">
          <p class="name">{{ playersDetails.homePlayerUsername }}</p>
          <p class="points" v-if="!currentModal"><span>{{ totalPointsDuringGame }} </span>{{ getTranslations.home_loader_points }}</p>
        </div>
        <div class="avatar">
          <img :src="playersDetails.homePlayerAvatar">
        </div>
      </div>
    </header>
    <div class="container-fluid" v-if="!$route.params.isResume">
      <div class="row score_page">
        <div class="container games_page">

          <div class="points_container">
            <div v-for="(item, index) in numberOfQuestionsPerRound" :key="index">
              <div :class="['points_box', index === currentQuestionNumber ? 'active' : '']">
                <div class="progress_text"><span>{{ personalizedData.correctPoints }}</span> {{ getTranslations.home_loader_points }}</div>
                <div :class="['progressbar', getHomePlayerAnswersHistory(index)]">
                  <div :id="[`progressId_${index}`]" class="progressbar__bar"
                       :data-percent="getHomePlayerAnswersHistory(index) === '' ? 0 : 100"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="score_game_counter" ref="progressBarTimer">
            <div class="progressbar">
              <div class="progressbar__bar" :style="progressBar"></div>
            </div>
          </div>
          <div v-if="personalizedData.scoreGameType === 'QUESTION' && randomizedAnswers.length != null && randomizedAnswers.length === 4">
          <h1>{{ personalizedData.questionText }}</h1>
          <div class="win_points"></div>
            <div class="gameplay_btns_col" v-if="personalizedData">
              <button v-for="answer in randomizedAnswers"
                      :key="answer.answerId"
                      type="button"
                      @click="registerUserAnswer(answer.answerId, answer.answerKey)"
                      :class="getAnswerCSSClasses(answer)"
                      :disabled="playerAnswered || timeIsUp">
                {{ answer.answerText }}
              </button>
            </div>
          </div>
          <div v-if="personalizedData.scoreGameType === 'WORDSALAD' && randomizedAnswers.length != null && randomizedAnswers.length === 4">
            <h1>{{ personalizedData.questionText }}</h1>
            <div class="win_points"></div>
            <div class="game_img">
              <img :src="getQuestionImage">
            </div>
            <div class="gameplay_btns_row">
              <div v-for="row in (randomizedAnswers.length / 2)"
                   :key="row"
                   class="gameplay_btns_col">
                <button v-for="answer in getPartOfAnswers(row)"
                        :key="answer.answerId"
                        type="button"
                        @click="registerUserAnswer(answer.answerId, answer.answerKey)"
                        :class="getAnswerCSSClasses(answer)"
                        :disabled="playerAnswered || timeIsUp">
                  {{ answer.answerText }}
                </button>
              </div>
            </div>
          </div>
          <div v-if="personalizedData.scoreGameType === 'VIDEO_QUESTION' && randomizedAnswers.length != null && randomizedAnswers.length === 5">
            <h1>{{ personalizedData.questionText }}</h1>
            <div class="win_points"></div>
            <div class="game_img">
              <img :src="getQuestionImage">
              <video-game :video-url="personalizedData.answerImageURL"/>
            </div>

            <div class="gameplay_btns_row btn_5 first_row">
              <button type="button" :class="getAnswerCSSClasses(videoQuestionAnswers.UPPER_LEFT)" @click="registerUserAnswerForVideo(videoQuestionAnswers.UPPER_LEFT)"
                      :disabled="playerAnswered || timeIsUp">{{ getTranslations.home_game_upper_left }}</button>
              <button type="button" :class="getAnswerCSSClasses(videoQuestionAnswers.UPPER_RIGHT)" @click="registerUserAnswerForVideo(videoQuestionAnswers.UPPER_RIGHT)"
                      :disabled="playerAnswered || timeIsUp">{{ getTranslations.home_game_upper_right }}</button>
            </div>
            <div class="gameplay_btns_row btn_5">
              <button type="button" :class="getAnswerCSSClasses(videoQuestionAnswers.CENTER)" @click="registerUserAnswerForVideo(videoQuestionAnswers.CENTER)"
                      :disabled="playerAnswered || timeIsUp">{{ getTranslations.home_game_center }}</button>
            </div>
            <div class="gameplay_btns_row btn_5 last_row">
              <button type="button" :class="getAnswerCSSClasses(videoQuestionAnswers.LOWER_LEFT)" @click="registerUserAnswerForVideo(videoQuestionAnswers.LOWER_LEFT)"
                      :disabled="playerAnswered || timeIsUp">{{ getTranslations.home_game_lower_left }}</button>
              <button type="button" :class="getAnswerCSSClasses(videoQuestionAnswers.LOWER_RIGHT)" @click="registerUserAnswerForVideo(videoQuestionAnswers.LOWER_RIGHT)"
                      :disabled="playerAnswered || timeIsUp" >{{ getTranslations.home_game_lower_right }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <component :is="currentModal" @playPostGameAddOn="playPostGameAddOn" @playNewGame="playNewGame"></component>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import webSocket from '@/common/webSocket';
import { equalHeightAndWidth } from '@/common/jQuery';
import $ from 'jquery';
import { ParseResponseMixin, GameMixin, GameMixin2 } from '@/common/mixins/game';
import PostGame from '@/components/home/modals/PostGame';
import LevelUp from '@/components/home/modals/LevelUp';
import NewGameMixin from '@/common/mixins/home';
import shuffle from 'knuth-shuffle-seeded';
import VideoGame from './Video';

export default {
  name: 'game',
  components: { VideoGame },
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin, GameMixin2],
  data() {
    return {
      timeIsUp: false,
      progressBarWidth: 100.0,
      progressBarWidthInPixels: 0,
      progressBarGradientColorLimit1: 0,
      progressBarGradientColorLimit2: 0,
      progressBarGradientColorLimit3: 0,
      timer: null,
      currentModal: null,
      showedModal: false,
      userLevel: 0,
      bonusPoints: 0,
      gamesEarned: 0,
      personalizedData: null,
      randomizedAnswers: [],
      playerAnswered: false,
      playerAnswerID: '',
      playerAnswerKey: '',
      currentQuestionID: -1,
      bothPlayersAnswered: false,
      stompClient: null,
      subscription1: null,
      subscription2: null,
      questionAnswerTime: 0,
      videoQuestionAnswers: {
        LOWER_LEFT: null,
        LOWER_RIGHT: null,
        CENTER: null,
        UPPER_LEFT: null,
        UPPER_RIGHT: null,
      },
    };
  },
  created() {
    // console.clear();
    console.log('in Game created hook');
    if (!this.$route.params.isResume) {
      this.stompClient = webSocket.getGameStompClient();
      console.log('this.stompClient:', this.stompClient);
      this.initQuestionData();
      this.getNextCTA();
      this.getThemesForNextRound();
    } else {
      this.openPostGameModal();
    }
  },
  mounted() {
    // console.clear();
    equalHeightAndWidth();
    if (!this.$route.params.isResume) this.setProgressBarGradientColorLimitsInPixels();
  },
  updated() {
    if (this.$refs.progressBarTimer !== undefined) {
      if (this.$refs.progressBarTimer.clientWidth !== this.progressBarWidthInPixels) {
        this.setProgressBarGradientColorLimitsInPixels();
      }
    }
  },
  beforeDestroy() {
    console.log('in game\'s beforeDestroy hook');
    // if for any reason we leave this component earlier from the websocket's response,
    // unsubscribe from the subscribed channels
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.resetPlayersAnswersHistoryCSSClasses();
    this.resetGameState();
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('game', [
      'setHomePlayerAnswer',
      'setAwayPlayerAnswer',
      'resetGameState',
      'resetPlayersAnswersHistoryCSSClasses',
    ]),
    ...mapMutations('profile', [
      'setShowmodalForLevelUp',
    ]),
    goToHomePage() {
      this.$router.push('/home');
      window.location.reload();
    },
    openPostGameModal() {
      this.normalTransition = true;
      setTimeout(() => {
        this.currentModal = PostGame;
        console.log('showing post game modal...');
        this.showHideModal();
      }, 5000);
    },
    getHomePlayerAnswersHistory(answerIndex) {
      const homePlayerAnswersHistory = this.homePlayerCorrectAnswersCSSClasses[answerIndex];
      return homePlayerAnswersHistory !== undefined ? homePlayerAnswersHistory : '';
    },
    stompFailure(error) {
      console.log(error);
      window.location.reload();
    },
    initAndStartTimer() {
      this.timeIsUp = false;
      this.countdown();
    },
    getNextCTA() {
      console.info(`Subscribing to channel: /topic/ctaSelected/${this.gameID}`);
      this.subscription1 = this.stompClient.subscribe(`/topic/ctaSelected/${this.gameID}`, (response) => {
        console.log('[Game] Inside ctaSelected response');
        // parse server response and return if any errors occur
        const responseBody = this.parseServerResponse(response.body);
        if (responseBody === null) {
          return;
        }
        const responseData = responseBody.data;
        console.log('responseData:', responseData);
        if (responseData.gameStateEnum === 'DISPLAY_CTA_TO_BE_ANSWERED' || responseData.gameStateEnum === 'SHOW_GAME_ROUND_END') {
          this.change();
          /* eslint-disable */
          let progressDiv =  $(`#progressId_${this.currentQuestionNumber}`);
          progressDiv.attr("data-percent", "100");
          progressDiv.css("width", "100%");
          /* eslint-enable */
          this.saveQuestionData(responseData);
        } else if (!this.gameIsResuming && responseData.gameStateEnum === 'CTA_TO_BE_ANSWERED') {
          this.normalTransition = true;
          this.saveQuestionDataForNextQuestion(responseData);
          this.initQuestionData();
          this.initializeElements();
        }
      });
    },
    getThemesForNextRound() {
      console.info(`Subscribing to channel: /topic/categoriesFetched/${this.gameID}`);
      this.subscription2 = this.stompClient.subscribe(`/topic/categoriesFetched/${this.gameID}`, (response) => {
        console.log('[Game] Inside categoriesFetched response');
        // parse server response and return if any errors occur
        const responseData = this.parseServerResponse(response.body);
        if (responseData === null) {
          return;
        }
        console.log('responseData:', responseData);
        if (responseData.gameStateEnum === 'GAME_FINISHED') {
          this.subscription1.unsubscribe();
          this.subscription2.unsubscribe();
          this.saveRoundData(responseData);
          this.openPostGameModal();
        }
      });
    },
    initQuestionData() {
      this.progressBarWidth = 100.0;
      this.timesForThisRound();
      console.log('initializing question data...');
      // init common data
      this.playerAnswered = false;
      this.playerAnswerKey = '';
      this.bothPlayersAnswered = false;
      this.personalizedData = this.isHomePlayer ? this.homePlayerQuestionDTO : '';
      console.log('this.personalizedData:', this.personalizedData);
      // first sort answers the same way for both players
      this.randomizedAnswers = this.personalizedData.answerDTOList.slice(0).sort((a, b) => a.answerKey - b.answerKey);
      if (this.personalizedData.scoreGameType === 'VIDEO_QUESTION') {
        console.log('Video Question');
        this.videoQuestionAnswers.CENTER = this.personalizedData.answerDTOList.find(answer => answer.answerText === 'CENTER');
        this.videoQuestionAnswers.LOWER_LEFT = this.personalizedData.answerDTOList.find(answer => answer.answerText === 'LOWERLEFT');
        this.videoQuestionAnswers.LOWER_RIGHT = this.personalizedData.answerDTOList.find(answer => answer.answerText === 'LOWERRIGHT');
        this.videoQuestionAnswers.UPPER_LEFT = this.personalizedData.answerDTOList.find(answer => answer.answerText === 'UPPERLEFT');
        this.videoQuestionAnswers.UPPER_RIGHT = this.personalizedData.answerDTOList.find(answer => answer.answerText === 'UPPERRIGHT');
      } else {
        console.log('this.randomizedAnswers:', this.randomizedAnswers);
        const seed = (this.gameID * (this.currentQuestionNumber + 1)) / this.currentRoundNumber;
        // using Fisher Yates shuffle algorithm, generate a new shuffled array with the answers
        // but with the same ordering for both players (using a seed)
        console.log('this.seed:', seed);
        shuffle(this.randomizedAnswers, seed);
      }
      this.setHomePlayerAnswer('');
      this.setAwayPlayerAnswer('');
      // init help data
      this.normalTransition = false;
      this.timeIsUp = false;
      console.log('calling initAndStartTimer()...');
      this.initAndStartTimer();
    },
    getPartOfAnswers(part) {
      if (part === 1) {
        return this.randomizedAnswers.slice(0, this.randomizedAnswers.length / 2);
      }
      return this.randomizedAnswers.slice(this.randomizedAnswers.length / 2);
    },
    registerUserAnswerForVideo(answer) {
      this.registerUserAnswer(answer.answerId, answer.answerKey);
    },
    registerUserAnswer(answerID, answerKey) {
      console.log('--> inside registerUserAnswer...');
      console.log('this.currentQuestionNumber:', this.currentQuestionNumber);
      console.log('this.playerAnswered:', this.playerAnswered);
      if (!this.playerAnswered && (this.currentQuestionNumber < this.numberOfQuestionsPerRound)) {
        this.playerAnswered = true;
        if (this.isHomePlayer) {
          console.log(`user ${this.playersDetails.homePlayerUsername} has answered with answer ${answerKey}...`);
          this.setHomePlayerAnswer(answerKey);
        } else {
          console.log(`user ${this.playersDetails.awayPlayerUsername} has answered with answer ${answerKey}...`);
          this.setAwayPlayerAnswer(answerKey);
        }
        this.playerAnswerID = answerID;
        this.playerAnswerKey = answerKey;
        clearInterval(this.timer);
        // eslint-disable-next-line
        $("#container").html("");
        console.log('sending player answer');
        this.$axios({
          url: `api/sendSelectedCta2?gameId=${this.gameID}&answer=${this.playerAnswerKey}&questionID=${this.personalizedData.questionId}&useBoost=`,
          method: 'GET',
          headers: {
            Authorization: this.jwtInVuex,
          },
        }).catch((error) => {
          console.log(`Invoking api/sendSelectedCta2 failed with the following error: ${error}`);
        });
      }
    },
    getAnswerCSSClasses(answer) {
      const classes = ['gameplay_btn select_answer rejected'];
      if (this.bothPlayersAnswered && (answer.answerId === this.correctAnswerID) && (this.playerAnswerID === answer.answerId)) {
        classes.push('gameplay_btn_correct');
      }
      if (this.bothPlayersAnswered && (answer.answerId !== this.correctAnswerID) && (this.playerAnswerID === answer.answerId) && (this.playerAnswerID !== this.correctAnswerID)) {
        classes.push('gameplay_btn_false');
      }
      if ((this.bothPlayersAnswered && (answer.answerId === this.correctAnswerID) && (this.playerAnswerID !== answer.answerId)) || (this.timeIsUp && answer.answerId === this.correctAnswerID)) {
        classes.push('gameplay_btn_correct');
      }
      return classes;
    },
    showHideModal() {
      this.$nextTick(() => {
        /* eslint-disable */
        $('.modal,.modal-overlay,.overlay').fadeIn(200);
        $("body").addClass("modal-open");
        if (this.soundsOn) {
          if (this.isGameWinner) {
            this.gameWonSound.play();
          } else {
            this.gameLostSound.play();
          }
        }
        $('.modal-close,.modal-overlay,.overlay,.btn_close').click(() => {
          $(".popup_box").fadeOut(200);
          $(".overlay").fadeOut(200);
          $('.modal, .modal-overlay').fadeOut();
          $("body").removeClass("modal-open");
          console.log('RoundEnded' + this.userLeveledUp + this.showedModal);
          /* eslint-enable */
          if (this.userLeveledUp && !this.showedModal) {
            const notificationLevelupData = {
              userLevel: this.isHomePlayer ? this.homePlayerLevel : this.awayPlayerLevel,
              bonusPoints: this.isHomePlayer ? this.homePlayerLevelUpBonusPoints : this.awayPlayerLevelUpBonusPoints,
              gamesEarned: this.isHomePlayer ? this.homePlayerGamesEarned : this.awayPlayerGamesEarned,
            };
            console.log(`We have a special Notification ${notificationLevelupData}`);
            console.log(`We have a special Notification type with DATA: ${notificationLevelupData.userLevel}`);
            this.setShowmodalForLevelUp({ notificationLevelupObject: notificationLevelupData });
            this.getUserLoginDetails().then(() => {
              this.currentModal = LevelUp;
              this.showedModal = true;
              console.log('showing level up pop up');
              this.showHideModal();
            });
          } else {
            console.log('user has not leveled up, going to home page');
            this.currentModal = null;
            if (this.getUserAvailableGames === 0) {
              sessionStorage.removeItem('zeroBalancePopUp');
            }
            this.getUserLoginDetails().then(() => {
              this.$router.push('/home');
            });
          }
        });
      });
    },
    timesForThisRound() {
      this.questionAnswerTime = this.roundTimeList[0];
    },
    playPostGameAddOn() {
      this.normalTransition = true;
      this.getUserLoginDetails().then(() => {
        this.$router.push({
          name: 'postGameAddOn',
          params: {
            gameId: this.gameID,
            correctAnswers: this.homePlayerCorrectAnswersCSSClasses.filter(answer => answer === 'correct').length,
          },
        });
      });
    },
    playNewGame() {
      console.log('New Game button clicked in Post Game modal');
      this.normalTransition = true;
      this.currentModal = null;
      this.playGameForPages();
    },
    countdown() {
      this.timer = setInterval(() => {
        /* eslint-disable */
        this.progressBarWidth -= 2.5;
        if (this.progressBarWidth === 0.0) {
          this.timeIsUp = true;
          this.stopTimer();
        }
      }, ((this.questionAnswerTime) / 40));
    },
    stopTimer() {
      clearInterval(this.timer);
    },
    setProgressBarGradientColorLimitsInPixels() {
      /* eslint-disable */
      this.progressBarWidthInPixels = this.$refs.progressBarTimer.clientWidth;
      this.progressBarGradientColorLimit1 = this.progressBarWidthInPixels * 0.25;
      this.progressBarGradientColorLimit2 = this.progressBarWidthInPixels * 0.5;
      this.progressBarGradientColorLimit3 = this.progressBarWidthInPixels * 0.75;
    },
    change() {
      // change classes only for video games because hides images for other type of games
      if (this.personalizedData.scoreGameType === 'VIDEO_QUESTION') {
        $('.game_video').removeClass('d-none');
        $('.game_img img').addClass('d-none');
      }
    },
    initializeElements() {
      $('.game_img img').removeClass('d-none');
      $('.game_video').addClass('d-none');
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('common', [
      'roundTimeList',
      'userDetails',
      'soundsOn',
    ]),
    ...mapState('game', [
      'questionsPoints',
      'homeCorrectAnswers',
      'numberOfQuestionsPerRound',
      'gameIsResuming',
      'gameID',
      'playersDetails',
      'currentRoundNumber',
      'currentQuestionNumber',
      'correctAnswerID',
      'homePlayerQuestionDTO',
      'homePlayerAnswer',
      'homePlayerCorrectAnswersCSSClasses',
      'awayPlayerAnswer',
      'homePlayerLevel',
      'awayPlayerLevel',
      'awayPlayerLevelUpBonusPoints',
      'homePlayerLevelUpBonusPoints',
      'homePlayerGamesEarned',
      'awayPlayerGamesEarned',
      'userLeveledUp',
    ]),
    ...mapGetters('game', [
      'isHomePlayer',
      'isGameWinner',
    ]),
    ...mapGetters('common', [
      'getUserAvailableGames',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    getQuestionImage() {
      return this.bothPlayersAnswered ? this.personalizedData.answerImageURL : this.personalizedData.imageURL;
    },
    progressBar() {
      return {
        width: `${this.progressBarWidth}%`,
        background: `linear-gradient(to right,#E71010,#fc364a ${this.progressBarGradientColorLimit1}px,#FFE746 ${this.progressBarGradientColorLimit2}px,#8CCD82 ${this.progressBarGradientColorLimit3}px,#058412)`,
      };
    },
    totalPointsDuringGame() {
      return this.userDetails.totalPointsEarned + (this.homeCorrectAnswers * this.questionsPoints);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/Game.vue